const EXPERIENCE = [
  {
    name: 'Replicate (acq. Cloudflare)',
    year: '2025 —',
    description: 'Shipping models, hacking, and working on the developer platform.',
    position: 'Models Engineer',
    link: 'https://www.replicate.com/',
  },
  {
    name: 'FLORA AI',
    year: '2024',
    description: 'Shipped AI tools for creatives.',
    position: 'Platform Engineer',
    link: 'https://www.florafauna.ai/',
  },
  {
    name: 'Autodesk Research',
    year: '2023',
    description:
      'Developed auto-labeling technology for Autodesk Viewer CAD files using finetuned BLIP-2 models.',
    position: 'Data Acquisition + Machine Learning',
    link: 'https://medium.com/@shridharathi/employing-pretrained-vision-and-language-models-to-auto-label-cad-files-d872cad2299a',
  },
  {
    name: 'NVIDIA',
    year: '2021',
    description:
      "Contributed to RAPIDS, pandas on the GPU. Accelerated read_csv calls on AWS S3 files by 3.5x using Apache Arrow.",
    position: 'Data Engineering',
    link: 'https://medium.com/@shridharathi/speed-up-s3-csv-file-reading-with-apache-arrow-5c0e181e6c58',
  },
  {
    name: 'Stanford FUSE',
    year: '2020',
    description:
      'Digitized the entire water distribution system of Pune, India.',
    position: 'Data Science',
    link: 'https://agu.confex.com/agu/fm20/meetingapp.cgi/Paper/735906',
  },
];
export default EXPERIENCE;
